module.exports = __webpack_public_path__ + "media/images/service/zl_code-59eaed2fc3e5e31d56b850fd08c61e4a.png";